import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import HomeMobileNavbar from "../components/HomeMobileNavbar";

const faqsData = [
  {
    id: "01",
    title: "Helloo",
    items: [
      {
        q: (
          <>
            Looking to talk? We&apos;d love to! Our contact details are mentioned below. In case you have a question, please check out the{' '}
            <a href="/faqs" className="underline hover:opacity-70">FAQs</a>
            {' '}first.
          </>
        ),
        noDivider: true,
      },
      {
        q: (
          <>
            Email:{' '}
            <a href="mailto:people@nufab.studio" className="underline hover:opacity-70">people@nufab.studio</a>
          </>
        ),
      },
      {
        q: "Whatsapp: +91 9244501941",
      },
      {
        q: (
          <>
            Instagram:{' '}
            <a
              href="https://www.instagram.com/nufab.studio"
              target="_blank"
              rel="noreferrer"
              className="underline hover:opacity-70"
            >
              @nufab.studio
            </a>
          </>
        ),
      },
      {
        q: (
          <>
            Studio Address:{' '}
            <a
              href="https://www.google.com/maps/search/?api=1&query=201%2C%2076-77%20P-Prime%2C%20Shakti%20Nagar%2C%20452018%2C%20Indore"
              target="_blank"
              rel="noreferrer"
              className="underline hover:opacity-70"
            >
              201, 76-77 P-Prime, Shakti Nagar, 452018, Indore
            </a>
          </>
        ),
      },
      {
        q: "Support Hours: Monday to Saturday, 11:00 AM – 7:00 PM IST",
      },
    ],
  }
];

const ContactPage = () => {
  const [windowWidth, setWindowWidth] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
 React.useEffect(() => {
     const handleResize = () => setWindowWidth(window.innerWidth);
     window.addEventListener('resize', handleResize);
     return () => window.removeEventListener('resize', handleResize);
   }, []);
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      {windowWidth < 1168 ? <HomeMobileNavbar /> : <Navbar />}
    <div className="w-full max-w-full mx-auto px-4 md:px-6 py-10 md:py-20 font-[bdogrotesk] text-black">
      <p className="text-black text-lg font-medium mb-6 md:mb-0">Contact Us</p>
      {faqsData.map((section, sectionIdx) => (
        <div
          key={section.id}
          // RESPONSIVE: Stack vertically on mobile, horizontal on desktop
          className={`flex flex-col lg:flex-row gap-6 lg:gap-10 pt-10 pb-10 lg:pb-0 ${sectionIdx !== faqsData.length - 1 ? "border-b border-black" : ""}`}
        >
          {/* Left column (ID) */}
          <div className="text-base font-medium text-black tracking-wide w-full lg:w-20 flex-shrink-0">
            {section.id}
          </div>

          {/* Right column Wrapper */}
          <div className="flex-1 flex flex-col gap-8 lg:grid lg:grid-cols-[minmax(260px,1fr)_minmax(560px,1.2fr)] lg:items-start lg:gap-10">
            
            {/* Title */}
            {/* RESPONSIVE: Scale font size and center title block on desktop */}
            <h2 className="w-full max-w-[420px] text-3xl md:text-5xl lg:text-6xl font-medium break-words lg:justify-self-center">
              {section.title}
            </h2>

            {/* Items List */}
            <div className="space-y-4 w-full">
              {section.items.map((item, itemIdx) => {
                const key = `${sectionIdx}-${itemIdx}`;
                const isLast = itemIdx === section.items.length - 1;
                const showDivider = !isLast && !item.noDivider;

                return (
                  <div
                    key={key}
                    className={`${showDivider ? "border-b border-black" : ""} pb-4`}
                  >
                    <button
                      className="w-full flex justify-between items-start text-left cursor-default"
                    >
                      <span className="text-sm md:text-base text-black font-medium pr-0 md:pr-6 leading-relaxed">
                        {item.q}
                      </span>
                    </button>

                    {/* Hidden answer div to maintain structure if needed later */}
                    <div className={`overflow-hidden transition-all duration-300 ease-in-out hidden`}>
                      <div className="overflow-hidden">
                        <p className="text-base leading-relaxed pr-10">
                          {/* {item.a} */}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};

export default ContactPage;